import CartEmptyCostBlockNew from './CartEmptyCostBlockNew'

export default CartEmptyCostBlockNew
